module.exports = __webpack_public_path__ + "images/category_lp/jewel/assessment_achievements/1_76ed82f522de1e38c9c911d1a572b6ca.png";